import { Check, ArrowRight } from "lucide-react";
import { Reveal } from "../components/Reveal";

const HERO_IMG = "/images/hero-class.jpg";

const bullets = [
  "Completely Free, No Hidden Cost",
  "No Past Experience Needed",
  "Honest Advice, Not a Sales Pitch",
];

const cardPoints = ["Real teacher, live", "Every session recorded", "Doubt support anytime"];

export const Hero = ({ onCta }) => (
  <section className="relative overflow-hidden" style={{ background: "var(--bg-primary)" }} data-testid="hero-section">
    <div className="hero-glow" />
    <div className="relative max-w-6xl mx-auto px-5 pt-12 pb-20 sm:pt-16 sm:pb-24 grid gap-12 lg:grid-cols-2 items-center">
      <div className="text-center lg:text-left">
        <Reveal>
          <span
            className="inline-flex items-center gap-2 rounded-full px-4 py-1.5 text-xs font-semibold tracking-wide uppercase"
            style={{ color: "var(--accent)", border: "1px solid rgba(14, 217, 181, 0.3)", background: "rgba(14, 217, 181, 0.06)" }}
            data-testid="hero-badge"
          >
            <span className="relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full opacity-60" style={{ background: "var(--accent)" }} />
              <span className="relative inline-flex rounded-full h-2 w-2" style={{ background: "var(--accent)" }} />
            </span>
            Trusted Career Training Institute
          </span>
        </Reveal>
        <Reveal delay={100}>
          <h1 className="font-display mt-6 text-4xl sm:text-5xl lg:text-6xl font-semibold uppercase leading-[1.08] text-white" data-testid="hero-headline">
            Land a <span style={{ color: "var(--accent)" }}>Good Job</span> in AI, Cybersecurity, or Data Science — Starting Today.
          </h1>
        </Reveal>
        <Reveal delay={200}>
          <p className="mt-6 text-base sm:text-lg leading-relaxed max-w-xl mx-auto lg:mx-0" style={{ color: "var(--text-body)" }} data-testid="hero-subheadline">
            Not sure which path is right for you? Talk to our career expert. In just 20 minutes, find out
            if this course suits you best.
          </p>
        </Reveal>
        <Reveal delay={300}>
          <ul className="mt-7 flex flex-col sm:flex-row flex-wrap items-center lg:items-start justify-center lg:justify-start gap-2.5 sm:gap-x-6" data-testid="hero-trust-bullets">
            {bullets.map((b) => (
              <li key={b} className="flex items-center gap-2 text-sm" style={{ color: "var(--text-body)" }}>
                <Check size={16} style={{ color: "var(--accent)" }} strokeWidth={3} />
                {b}
              </li>
            ))}
          </ul>
        </Reveal>
        <Reveal delay={400}>
          <div className="mt-9">
            <button
              data-testid="hero-cta-button"
              onClick={onCta}
              className="cta-button inline-flex items-center gap-2 rounded-full px-8 py-4 text-base sm:text-lg font-bold"
            >
              Book My Free Session
              <ArrowRight size={20} />
            </button>
            <p className="mt-4 text-sm" style={{ color: "var(--text-muted)" }} data-testid="hero-micro-line">
              Takes 30 seconds. We'll call you within 24 hours.
            </p>
          </div>
        </Reveal>
      </div>

      <Reveal delay={250} className="relative">
        <div className="relative" data-testid="hero-image-card">
          <div className="absolute -inset-4 rounded-3xl" style={{ background: "rgba(14, 217, 181, 0.06)", filter: "blur(24px)" }} />
          <img
            src={HERO_IMG}
            alt="A live training session with students and a mentor"
            loading="eager"
            className="relative w-full rounded-2xl object-cover aspect-[4/3]"
            style={{ border: "1px solid var(--input-border)" }}
            data-testid="hero-image"
          />
          <div
            className="absolute top-4 left-4 inline-flex items-center gap-2 rounded-full px-3.5 py-1.5 text-xs font-semibold"
            style={{ background: "rgba(13, 17, 23, 0.85)", backdropFilter: "blur(8px)", border: "1px solid var(--input-border)", color: "var(--accent)" }}
            data-testid="hero-live-badge"
          >
            <span className="relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full opacity-60" style={{ background: "var(--accent)" }} />
              <span className="relative inline-flex rounded-full h-2 w-2" style={{ background: "var(--accent)" }} />
            </span>
            Live Classes
          </div>
          <div
            className="absolute -bottom-6 right-3 sm:right-6 rounded-xl p-4"
            style={{ background: "var(--bg-card)", border: "1px solid var(--input-border)", boxShadow: "0 12px 40px rgba(0,0,0,0.4)" }}
            data-testid="hero-highlights-badge"
          >
            <p className="text-xs font-semibold uppercase tracking-widest mb-2.5" style={{ color: "var(--text-muted)" }}>
              Every Class Includes
            </p>
            <ul className="space-y-1.5">
              {cardPoints.map((p) => (
                <li key={p} className="flex items-center gap-2 text-xs font-medium" style={{ color: "var(--text-body)" }}>
                  <Check size={13} style={{ color: "var(--accent)" }} strokeWidth={3} />
                  {p}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
